<template>
  <my-upload
    v-model="modalSignature"
    field="signature"
    langType="pt-br"
    img-format="jpg/png/svg"
    @crop-success="cropSuccess"
    @src-file-set="srcFileSet()"
    @input="cancel"
    :noCircle="true"
    :width="256"
    :height="128"
    ref="cropSignature"
  />
</template>

<script>
import myUpload from 'vue-image-crop-upload';
import Potrace from '@/utils/potrace';
import b64toBlob from 'b64-to-blob';

export default {
  name: 'ModalSignature',
  data() {
    return {
      imgDataUrl: '',
      firstSetImg: true,
    };
  },
  components: {
    myUpload,
  },
  methods: {
    toggleModalSignature(value) {
      this.$store.dispatch('toggleModalSignature', value);
    },
    restartData() {
      this.imgDataUrl = '';
      this.firstSetImg = true;
      this.$refs.cropSignature.setStep(1);
    },
    cancel() {
      this.toggleModalSignature(false);
      this.restartData();
    },
    cropSuccess(imgDataUrl) {
      this.imgDataUrl = imgDataUrl;
      this.$store.dispatch('updateUser', { userId: this.userId, signature: imgDataUrl });
      this.toggleModalSignature(false);
      this.restartData();
    },
    srcFileSet() {
      const file = event.target.files[0];
      setTimeout(() => {
        Potrace.loadImageFromFile(file);
        Potrace.process(() => {
          const svgstring = Potrace.getSVG(1);
          const encodedData = window.btoa(svgstring);
          const blob = b64toBlob(encodedData, 'image/svg+xml');
          this.$refs.cropSignature.setSourceImg(blob);
        });
      }, 400);
    },
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    modalSignature() {
      return this.$store.getters.modalSignature;
    },
    userId() {
      return this.$store.getters.user.id;
    },
  },
};
</script>

<style lang="scss">
// Override style layout (Crop)
.vicp-close {
  display: none;
}
.vicp-operate {
  & {
    right: 0 !important;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  a {
    & {
      color: rgba(0,0,0,.87) !important;
      text-transform: uppercase;
      font-weight: 500;
    }

    &.vicp-operate-btn {
      &,
      &:hover {
        background: rgb(48, 138, 251) !important;
        color: rgb(255, 255, 255) !important;
      }
    }
  }
}
.vicp-range {
  i {
    background: rgb(48, 138, 251) !important;
    color: rgb(255, 255, 255) !important;
  }

  input[type=range] {
    /* Slider
      ---------------------------------------------------------------*/
    &::-webkit-slider-thumb {
      background-color: rgb(48, 138, 251) !important;
    }
    &::-moz-range-thumb {
      background-color: rgb(48, 138, 251) !important;
    }
    &::-ms-thumb {
      background-color: rgb(48, 138, 251) !important;
    }

    /* Track
      ---------------------------------------------------------------*/
    &::-webkit-slider-runnable-track {
      background-color: rgba(0, 0, 0, 0.3) !important;
    }
    &::-moz-range-track {
      background-color: rgba(0, 0, 0, 0.3) !important;
    }
    &::-ms-fill-lower {
      background-color: rgba(0, 0, 0, 0.3) !important;
    }
    &::-ms-fill-upper {
      background-color: rgba(0, 0, 0, 0.3) !important;
    }

    &:focus {
      &::-webkit-slider-runnable-track {
        background-color: rgba(0, 0, 0, 0.15) !important;
      }
      &::-moz-range-track {
        background-color: rgba(0, 0, 0, 0.15) !important;
      }
      &::-ms-fill-lower {
        background-color: orange !important;
      }
      &::-ms-fill-upper {
        background-color: orange !important;
      }
    }
  }
}
.vicp-preview-item {
  & {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 0 !important;
    width: 240px !important;
    height: auto !important;
  }

  img {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
    border: none !important;
    order: 2;
  }
  span {
    top: auto !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
    position: relative !important;
    order: 1;
    color: #616161 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/signature/ModalSignature.vue